import { localStore } from '$lib/common';

export const userPhone = localStore('userPhone', "");
